import { render, staticRenderFns } from "./BlockBlogList.vue?vue&type=template&id=398c125c&scoped=true&"
import script from "./BlockBlogList.vue?vue&type=script&lang=js&"
export * from "./BlockBlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogList.vue?vue&type=style&index=0&id=398c125c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c125c",
  null
  
)

export default component.exports